const getFormattedLocations = (locations) => {
  const groupedByRegions =
    locations &&
    locations.reduce((regions, location) => {
      const found = regions.find((i) => i.id === location.region.id);
      if (found) {
        found.locations.push({ id: location.id, name: location.name });
        return regions;
      } else {
        return [
          ...regions,
          {
            id: location.region.id,
            name: location.region.name,
            locations: [
              {
                id: location.id,
                name: location.name,
              },
            ],
          },
        ];
      }
    }, []);
  return (
    groupedByRegions &&
    groupedByRegions.map((region) => {
      return {
        value: region.id,
        label: region.name,
        children: region.locations.map((location) => {
          return {
            value: location.id,
            label: location.name,
          };
        }),
      };
    })
  );
};

export default getFormattedLocations;
